















import { SfImage } from '~/components/StorefrontUi';
import { defineComponent } from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
  name: 'ProductsNoImage',
  components: {
    SfImage,
  },
  setup() {
    return {
      addBasePath,
    };
  },
});
